import {Injectable, OnInit} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class WalletPayeaseTypeService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('wallet-payease-type', http);
    }

    ngOnInit(): void {
    }

}
